import React from 'react'
import { useWatch } from 'react-hook-form'
import { Field } from '@Reusable/Field/Field'
import InputList from '@Reusable/InputList'
import { Form, Input, Select } from 'antd'

import { LeadScanQuestionFieldType } from '../interfaces'
import { FIELD_TYPES } from '../LeadScanQuestions'

export default function LeadScanQuestionForm() {
  const fieldType = useWatch<{ fieldType: LeadScanQuestionFieldType }>({ name: 'fieldType' })
  const hasOptions = FIELD_TYPES[fieldType]?.hasOptions

  return (
    <Form layout={'vertical'}>
      <Field
        label={'Question'}
        name={'title'}
        required
        rules={{ required: 'This field is required' }}
        render={({ field }) => <Input {...field} placeholder={'E.g. Premium'} />}
      />
      <Field
        label={'Field type'}
        name={'fieldType'}
        rules={{ required: 'This field is required' }}
        render={({ field }) => (
          <Select
            {...field}
            options={Object.entries(FIELD_TYPES).map(([value, { label }]) => ({ value, label }))}
          />
        )}
      />
      <Field
        label={'Options'}
        name={'options'}
        required={hasOptions}
        hidden={!hasOptions}
        rules={{
          required: hasOptions ? 'This field is required' : false,
          validate: (value) => {
            if (!hasOptions) return true

            const hasEmpty = value.some((value: string) => !value.trim())
            if (hasEmpty) {
              return false
            }
          }
        }}
        render={({ field }) => <InputList {...field} allowEmptyValues={false} />}
      />
    </Form>
  )
}
